// Rental types constants
export const RENTAL_PROPERTY_TYPES = {
  APARTMENT: "Căn hộ",
  LOW_RISE_PROJECT: "Thấp tầng dự án",
  PRIVATE_HOUSE: "Nhà thổ cư",
  LAND: "Đất nền",
};

// Direction options
export const DIRECTION_OPTIONS = [
  "Đông",
  "Tây",
  "Nam",
  "Bắc",
  "Đông Nam",
  "Đông Bắc",
  "Tây Nam",
  "Tây Bắc",
];

// Bedroom options - matches sale pricing format for consistency
export const BEDROOM_OPTIONS = [
  "1",
  "1PN +1",
  "2",
  "2PN+1",
  "3",
  "3PN+1",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  ">10",
];

// Apartment rental options
export const APARTMENT_RENTAL_OPTIONS = {
  types: [
    "Căn hộ chung cư",
    "Căn hộ penthouse",
    "Căn hộ duplex",
    "Căn hộ studio",
    "Office Tel",
    "Shophouse Chân đế",
    "Condotel",
    "Căn hộ chung cư mini",
    "Căn hộ dịch vụ (apartment)",
  ],
  tenantTypes: ["Người Việt Nam", "Người nước ngoài", "Doanh nghiệp/Công ty"],
  furnitureStatus: [
    "Nội thất đầy đủ",
    "Nội thất cơ bản liền tường",
    "Không có nội thất",
  ],
  rentalGoal: [
    "Cho thuê nhanh/gấp",
    "Không vội, muốn giá cao nhất",
    "Chỉ tham khảo thị trường",
  ],
};

// Low rise project rental options
export const LOW_RISE_RENTAL_OPTIONS = {
  types: [
    "Liền kề",
    "Biệt thự đơn lập",
    "Biệt thự song lập",
    "Biệt thự Tứ lập",
    "Shophouse",
    "Toà nhà văn phòng (nguyên toà)",
    "Khách sạn (nguyên toà)",
  ],
  tenantTypes: ["Người Việt Nam", "Người nước ngoài", "Doanh nghiệp/Công ty"],
  furnitureStatus: [
    "Nội thất đầy đủ",
    "Nội thất cơ bản liền tường",
    "Không có nội thất",
  ],
  rentalGoal: [
    "Cho thuê nhanh/gấp",
    "Không vội, muốn giá cao nhất",
    "Chỉ tham khảo thị trường",
  ],
};

// Private house rental options
export const PRIVATE_HOUSE_RENTAL_OPTIONS = {
  types: [
    "Nhà riêng",
    "Nhà mặt phố",
    "Chung cư mini (nguyên cả toà)",
    "Khách sạn (nguyên cả toà)",
    "Toà nhà văn phòng (nguyên cả toà)",
    "Dãy phòng trọ (nguyên dãy)",
  ],
  tenantTypes: ["Người Việt Nam", "Người nước ngoài", "Doanh nghiệp/Công ty"],
  furnitureStatus: [
    "Nội thất đầy đủ",
    "Nội thất cơ bản liền tường",
    "Không có nội thất",
  ],
  rentalGoal: [
    "Cho thuê nhanh/gấp",
    "Không vội, muốn giá cao nhất",
    "Chỉ tham khảo thị trường",
  ],
};

// Land rental options
export const LAND_RENTAL_OPTIONS = {
  types: [
    "Đất nền dự án",
    "Đất ở phân lô bán nền",
    "Đất nông nghiệp",
    "Đất thương mại dịch vụ",
    "Đất công nghiệp",
  ],
  tenantTypes: ["Người Việt Nam", "Người nước ngoài", "Doanh nghiệp/Công ty"],
  landCondition: [
    "Đất trống",
    "Có công trình cũ",
    "Đất trồng cây",
    "Đất nuôi trồng thủy sản",
  ],
  rentalGoal: [
    "Cho thuê nhanh/gấp",
    "Không vội, muốn giá cao nhất",
    "Chỉ tham khảo thị trường",
  ],
};

// Main rental form configuration
export const RENTAL_FORM_CONFIG = {
  [RENTAL_PROPERTY_TYPES.APARTMENT]: {
    dropdownFields: [
      {
        key: "apartmentType",
        label: "Loại căn hộ",
        options: APARTMENT_RENTAL_OPTIONS.types,
        required: true,
      },
      {
        key: "tenantType",
        label: "Khách thuê nhà",
        options: APARTMENT_RENTAL_OPTIONS.tenantTypes,
        required: true,
      },
      {
        key: "furnitureStatus",
        label: "Tình trạng nội thất",
        options: APARTMENT_RENTAL_OPTIONS.furnitureStatus,
        required: true,
      },
      {
        key: "rentalGoal",
        label: "Mục tiêu check giá thuê",
        options: APARTMENT_RENTAL_OPTIONS.rentalGoal,
        required: true,
      },
      {
        key: "balconyDirection",
        label: "Hướng ban công",
        options: DIRECTION_OPTIONS,
        required: true,
      },
      {
        key: "bedrooms",
        label: "Số phòng ngủ",
        options: BEDROOM_OPTIONS,
        required: true,
      },
    ],
    inputFields: [
      { key: "projectName", label: "Tên dự án", type: "text", required: true },
      { key: "address", label: "Địa chỉ", type: "text", required: true },
      { key: "building", label: "Toà/Khu", type: "text", required: false },
      { key: "floor", label: "Tầng/Dãy", type: "text", required: false },
      {
        key: "apartmentCode",
        label: "Mã căn hộ",
        type: "text",
        required: false,
      },
      { key: "bathrooms", label: "Số WC", type: "number", required: true },
      { key: "area", label: "Diện tích (m2)", type: "number", required: true },
      {
        key: "constructionYear",
        label: "Năm xây dựng/bàn giao",
        type: "number",
        required: false,
      },
      {
        key: "notes",
        label: "Ghi chú",
        type: "textarea",
        required: false,
        placeholder: "Ví dụ: nhà mới sửa, nội thất nhập khẩu, căn góc...",
      },
    ],
  },

  [RENTAL_PROPERTY_TYPES.LOW_RISE_PROJECT]: {
    dropdownFields: [
      {
        key: "houseType",
        label: "Loại nhà",
        options: LOW_RISE_RENTAL_OPTIONS.types,
        required: true,
      },
      {
        key: "tenantType",
        label: "Khách thuê nhà",
        options: LOW_RISE_RENTAL_OPTIONS.tenantTypes,
        required: true,
      },
      {
        key: "furnitureStatus",
        label: "Tình trạng nội thất",
        options: LOW_RISE_RENTAL_OPTIONS.furnitureStatus,
        required: true,
      },
      {
        key: "rentalGoal",
        label: "Mục tiêu check giá thuê",
        options: LOW_RISE_RENTAL_OPTIONS.rentalGoal,
        required: true,
      },
      {
        key: "doorDirection",
        label: "Hướng cửa",
        options: DIRECTION_OPTIONS,
        required: true,
      },
      {
        key: "bedrooms",
        label: "Số phòng ngủ",
        options: BEDROOM_OPTIONS,
        required: true,
      },
    ],
    inputFields: [
      { key: "projectName", label: "Tên dự án", type: "text", required: true },
      { key: "address", label: "Địa chỉ", type: "text", required: true },
      { key: "building", label: "Toà/Khu", type: "text", required: false },
      { key: "floor", label: "Tầng/Dãy", type: "text", required: false },
      {
        key: "apartmentCode",
        label: "Mã căn hộ",
        type: "text",
        required: false,
      },
      {
        key: "landLength",
        label: "Chiều dài đất (m)",
        type: "number",
        required: true,
      },
      {
        key: "frontage",
        label: "Mặt tiền (m)",
        type: "number",
        required: true,
      },
      { key: "floors", label: "Số tầng", type: "number", required: true },
      { key: "bathrooms", label: "Số WC", type: "number", required: true },
      {
        key: "landArea",
        label: "Diện tích đất (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionArea",
        label: "Diện tích xây dựng (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionYear",
        label: "Năm xây dựng/bàn giao",
        type: "number",
        required: false,
      },
      {
        key: "notes",
        label: "Ghi chú",
        type: "textarea",
        required: false,
        placeholder: "Ví dụ: nhà mới sửa, nội thất nhập khẩu, căn góc...",
      },
    ],
  },

  [RENTAL_PROPERTY_TYPES.PRIVATE_HOUSE]: {
    dropdownFields: [
      {
        key: "houseType",
        label: "Loại nhà",
        options: PRIVATE_HOUSE_RENTAL_OPTIONS.types,
        required: true,
      },
      {
        key: "tenantType",
        label: "Khách thuê nhà",
        options: PRIVATE_HOUSE_RENTAL_OPTIONS.tenantTypes,
        required: true,
      },
      {
        key: "furnitureStatus",
        label: "Tình trạng nội thất",
        options: PRIVATE_HOUSE_RENTAL_OPTIONS.furnitureStatus,
        required: true,
      },
      {
        key: "rentalGoal",
        label: "Mục tiêu check giá thuê",
        options: PRIVATE_HOUSE_RENTAL_OPTIONS.rentalGoal,
        required: true,
      },
      {
        key: "doorDirection",
        label: "Hướng cửa",
        options: DIRECTION_OPTIONS,
        required: true,
      },
      {
        key: "bedrooms",
        label: "Số phòng ngủ",
        options: BEDROOM_OPTIONS,
        required: true,
      },
    ],
    inputFields: [
      {
        key: "address",
        label:
          "Địa chỉ (Ghi rõ: Số nhà, ngõ/hẻm, đường/phố, quận/huyện, tỉnh/thành phố)",
        type: "textarea",
        required: true,
      },
      {
        key: "landLength",
        label: "Chiều dài mảnh đất (m)",
        type: "number",
        required: true,
      },
      {
        key: "frontage",
        label: "Mặt tiền (m)",
        type: "number",
        required: true,
      },
      { key: "floors", label: "Số tầng", type: "number", required: true },
      { key: "bathrooms", label: "Số WC", type: "number", required: true },
      {
        key: "landArea",
        label: "Diện tích đất (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionArea",
        label: "Diện tích xây dựng (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionYear",
        label: "Năm xây dựng/bàn giao",
        type: "number",
        required: false,
      },
      {
        key: "notes",
        label: "Ghi chú",
        type: "textarea",
        required: false,
        placeholder: "Ví dụ: nhà mới sửa, nội thất nhập khẩu, căn góc...",
      },
    ],
  },

  [RENTAL_PROPERTY_TYPES.LAND]: {
    dropdownFields: [
      {
        key: "landType",
        label: "Loại đất",
        options: LAND_RENTAL_OPTIONS.types,
        required: true,
      },
      {
        key: "tenantType",
        label: "Khách thuê đất",
        options: LAND_RENTAL_OPTIONS.tenantTypes,
        required: true,
      },
      {
        key: "landCondition",
        label: "Tình trạng đất",
        options: LAND_RENTAL_OPTIONS.landCondition,
        required: true,
      },
      {
        key: "rentalGoal",
        label: "Mục tiêu check giá thuê",
        options: LAND_RENTAL_OPTIONS.rentalGoal,
        required: true,
      },
      {
        key: "landDirection",
        label: "Hướng",
        options: DIRECTION_OPTIONS,
        required: true,
      },
    ],
    inputFields: [
      { key: "projectName", label: "Tên dự án", type: "text", required: true },
      { key: "address", label: "Địa chỉ", type: "text", required: true },
      { key: "landCode", label: "Mã lô đất", type: "text", required: false },
      {
        key: "landLength",
        label: "Chiều dài đất (m)",
        type: "number",
        required: true,
      },
      {
        key: "frontage",
        label: "Mặt tiền (m)",
        type: "number",
        required: true,
      },
      {
        key: "landArea",
        label: "Diện tích (m2)",
        type: "number",
        required: true,
      },
      {
        key: "notes",
        label: "Ghi chú",
        type: "textarea",
        required: false,
        placeholder: "Ví dụ: đất góc 2 mặt tiền, gần trung tâm...",
      },
    ],
  },
};

// Default form data for rentals
export const getDefaultRentalFormData = () => ({
  propertyType: "",

  // Dropdown values
  apartmentType: "",
  houseType: "",
  landType: "",
  tenantType: "",
  furnitureStatus: "",
  landCondition: "",
  rentalGoal: "",
  balconyDirection: "",
  doorDirection: "",
  landDirection: "",
  bedrooms: "",

  // Input values
  projectName: "",
  address: "",
  building: "",
  floor: "",
  apartmentCode: "",
  landCode: "",
  bathrooms: "",
  area: "",
  landLength: "",
  frontage: "",
  floors: "",
  landArea: "",
  constructionArea: "",
  constructionYear: "",
  notes: "",
});
